define('views/pages/favorites/index',['require','jquery','lib/utils','helpers/application','views/base/page','views/pages/favorites/providers/index','views/pages/favorites/goods/index','text!templates/pages/favorites/index.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        utils = require('lib/utils'),
        applicationHelper = require('helpers/application'),
        PageView = require('views/base/page'),
        FavoritesProvidersView = require('views/pages/favorites/providers/index'),
        FavoritesGoodsView = require('views/pages/favorites/goods/index'),
        template = require('text!templates/pages/favorites/index.ejs');

    var PagesFavoritesPageView = PageView.extend({
        id: 'pages-favorites-page',
        autoRender: true,
        template: template,
        regions: {
            'providers': '#favorites-providers',
            'goods': '#favorites-goods'
        },
        listen: {
            'change:loading model': 'render',
            'change:page model': 'onChangePage'
        },
        initialize: function() {
            PageView.prototype.initialize.apply(this, arguments);

            this.delegate('click', '#favorites-tabs>.nav-tabs a', this.onActivateTab);
        },
        render: function() {
            PageView.prototype.render.apply(this, arguments);

            this.subview('providers', new FavoritesProvidersView({ model: this.model.providers }));
            this.subview('goods', new FavoritesGoodsView({ model: this.model.goods }));
        },
        onChangePage: function(){
           applicationHelper.redirectTo('favorites#show', { page: this.model.get('page'), favFilter: 'favs' });
        },
        onActivateTab: function(ev){
            this.model.set('page', ev.target.href.split('-').pop());
        },
        dispose: function() {
            if (this.disposed) { return; }
            PageView.prototype.dispose.apply(this, arguments);
        }
    });

    return PagesFavoritesPageView;
});

